import {
  Component,
  AfterViewChecked,
  ChangeDetectionStrategy,
} from "@angular/core";
import { MAT_HAMMER_OPTIONS } from "@angular/material/core";
import { FieldType } from "@kre-form/core";
import * as _ from "lodash";
@Component({
  selector: "krefield-select",
  template: `
    <ng-container *ngIf="formStatus !== 0; else other">
      <div class="control-design">
        <input nz-input disabled />
      </div>
    </ng-container>

    <ng-template #other>
      <ng-container *ngIf="editor === true">
        <nz-select
          [nzAllowClear]="!to.required && clear"
          [nzMode]="to.selectType === 'multiple' ? 'multiple' : 'default'"
          [kreFormAttributes]="field"
          [class.is-invalid]="showError"
          [nzPlaceHolder]="placeHolder"
          [(ngModel)]="getModelValue"
          nzShowSearch="true"
          (ngModelChange)="selectedChange($event)"
        >
          <ng-container *ngFor="let item of to.options">
            <nz-option
              [nzLabel]="item.label"
              [nzValue]="item.value"
            ></nz-option>
          </ng-container>
        </nz-select>
        <!-- <div class="tips">
          <i
            class="icon-bangzhu"
            [nzTooltipTitle]="tips"
            nzTooltipPlacement="top"
            nz-tooltip
            *ngIf="tips != ''"
          ></i>
        </div> -->
      </ng-container>
      <div class="fieldtext" *ngIf="editor === false">
        {{ getSelectText() }}
      </div>
    </ng-template>
  `,
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KreFormFieldSelect extends FieldType {
  _defaultValue: string = "";
  _defaultValues: string[] = [];
  selectType = "default";
  listOfSelectedValue: any;

  get getModelValue() {
    if (this.to.selectType === "multiple") {
      return this.defaultValues;
    } else {
      return this.defaultValue;
    }
  }

  set getModelValue(value: any) {}

  get defaultValue() {
    if (
      this.model &&
      this.model[this.key] &&
      Array.isArray(this.model[this.key]) &&
      this.model[this.key].length > 0
    ) {
      this._defaultValue = this.model[this.key][0].value;
    } else {
      return null;
    }
    return this._defaultValue;
  }
  get defaultValues() {
    if (
      this.model &&
      this.model[this.key] &&
      Array.isArray(this.model[this.key])
    ) {
      this._defaultValues.length = 0;
      this.model[this.key].forEach((item: any) => {
        this._defaultValues.push(item.value);
      });
    } else {
      return null;
    }
    return this._defaultValues;
  }

  // get defaultValues() {
  //   if (!this._defaultValues) {
  //     this._defaultValues = [];
  //   } else {
  //     this._defaultValues.length = 0;
  //   }
  //   if (
  //     this.model &&
  //     this.model[this.key] &&
  //     Array.isArray(this.model[this.key]) &&
  //     !_.isEmpty(this.model[this.key])
  //   ) {
  //     if (!!this.model[this.key]) {
  //       this.model[this.key].forEach((item: any) => {
  //         this._defaultValues.push(item.value);
  //       });
  //     }
  //   } else {
  //     this._defaultValues = null;
  //   }
  //   return this._defaultValues;
  // }

  getSelectText() {
    let result: string = "";
    if (this.to && this.to.selectType) {
      if (this.to.selectType === "multiple") {
        result = this.textMultiple;
      } else {
        result = this.textSingle;
      }
    } else {
      result = this.textSingle;
    }
    return result;
  }

  selectedChange(e: any) {
    let values: any[] = [];
    if (this.to.selectType && this.to.selectType == "multiple") {
      if (e && Array.isArray(e)) {
        e.forEach((item: any) => {
          if (this.to.options && Array.isArray(this.to.options)) {
            this.to.options.forEach((options: any) => {
              if (options.value == item) {
                values.push(options);
              }
            });
          }
        });
      }
    } else {
      if (this.to.options && Array.isArray(this.to.options)) {
        this.to.options.forEach((options: any) => {
          if (options.value == e) {
            values = [options];
          }
        });
      }
    }
    this.formControl.patchValue(values);
    this.formControl.markAsTouched();
  }

  get clear(): boolean {
    if (typeof this.to.clear === "undefined") {
      return true;
    }

    return !!this.to.clear;
  }
}
